import { FundType } from '../types/FundType';
import { apiGet } from './client';

export function getFundTypes(): Promise<FundType[]> {
  return apiGet<FundType[]>('/api/fund-types');
}
